import { useColorModeValue } from '@chakra-ui/react';

export const useMenuBackgroundHoverColor = () => {
  const hoverColor = useColorModeValue(
    'background.light.hover',
    'background.dark.hover',
  );
  return { hoverColor };
};
